<ng-container>
  <div class="course-name LCS_sm-course-name">
    <h2 [ngClass]="{'LCS_upcoming-title': isUpcomming , 'LCS_ongoing-title': isOnGoing}"><span>{{courseData?.title}}</span></h2>
    <div class="ml-auto text-uppercase"
      [ngClass]="{'bd-live LCM_bd-live': isOnGoing, 'bd-upcoming LCM_bd-upcoming': isUpcomming}">
      {{getClassStatusText()}}
    </div>
  </div>
  <div class="class-box">
    <div class="d-flex top-info border-bottom">
      <div class="w-100">
        <span><img src="assets/img/grad-cap.png" alt=""> Grade {{courseData?.grade}}</span>
        <span class="border-left"><img src="assets/img/clock.png" alt=""> {{courseData?.duration}} Hours</span>
      </div>
      <div class="flex-shrink-1 bd-language">{{courseData?.language}}</div>
    </div>
    <div class="d-flex mb-3 border-bottom py-0 course-timeline">
      <h5>From <span>{{courseData?.schedule?.startDate | date: 'd MMM, YYYY'}}</span> to <span>{{courseData?.schedule?.endDate | date: 'd MMM, YYYY'}}</span></h5>
    </div>
    <div class="subject-box">
      <h6>Your Subject(s)</h6>
      <ng-container>
        <span class="badge badge-pill badge-light" *ngFor="let sub of courseData?.subjects"><img src="assets/img/subject-icons/{{sub.toLowerCase()}}-icon.svg" alt=""> {{sub}}</span>
      </ng-container>
    </div>
    <div class="d-flex border-top mt-3 pt-3 date-details">
      <div class="d-flex justify-content-between mt-1 px-3">
        <button class="btn btn-info" [routerLink]="['/mycourse/', courseData.id]"   type="button">VIEW COURSE</button>
      </div>
    </div>
  </div>
</ng-container>